import React from "react";
import { connect } from "react-redux";
import { Navigate } from "react-router-dom";

// Loader temporal mentre Redux resol l'estat d'autenticacio inicial.
function AuthRouteFallback() {
  return (
    <div className="d-flex min-vh-100 align-items-center justify-content-center bg-light">
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Cargando sesión</span>
      </div>
    </div>
  );
}

function PrivateRoute({ children, authResolved, isAuthenticated, user, isSuperAdmin, allowCallAgent = true }) {
  // Encara no sabem si hi ha sessio: mostrem spinner per evitar redireccions prematures.
  if (!authResolved) {
    return <AuthRouteFallback />;
  }

  // Sense sessio valida, redirigeix a login.
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Guard de rol: en rutes restringides, un CallAgent (no superadmin) torna a inici.
  if (!allowCallAgent && Boolean(user?.is_call_agent) && !isSuperAdmin) {
    return <Navigate to="/" replace />;
  }

  // Si passa tots els guards, es renderitza el contingut protegit.
  return <>{children}</>;
}

// Dades d'autenticacio i rol necessaries per avaluar els guards de ruta.
const mapStateToProps = (state) => ({
  authResolved: state.Auth.authResolved,
  isAuthenticated: state.Auth.isAuthenticated,
  user: state.Auth.user,
  isSuperAdmin: state.Auth.isSuperAdmin,
})
export default connect(mapStateToProps)(PrivateRoute);
